/* Frikytopia - mejoras de artículo (progreso de lectura, copiar enlace). Aditivo y sin dependencias. */
(function () {
  'use strict';

  // ---- Barra de progreso de lectura (solo en artículos) ----
  function initReadingProgress() {
    var article = document.querySelector('.article .article__block.rich-text, .article__content, article.article');
    if (!article) return;
    if (document.querySelector('.friky-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'friky-progress';
    bar.innerHTML = '<span class="friky-progress__fill"></span>';
    document.body.appendChild(bar);
    var fill = bar.firstChild;
    function onScroll() {
      var el = document.querySelector('.article__content') || article;
      var rect = el.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), total > 0 ? total : 1);
      var pct = total > 0 ? (scrolled / total) * 100 : 0;
      fill.style.width = pct.toFixed(1) + '%';
      bar.classList.toggle('is-visible', rect.top < window.innerHeight && rect.bottom > 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  // ---- Copiar enlace (botón de compartir) ----
  function initCopyLink() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-friky-copy]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('data-friky-copy') || window.location.href;
      var done = function () {
        var tip = btn.querySelector('.tooltip');
        var prev = tip ? tip.textContent : '';
        if (tip) { tip.textContent = '¡Copiado!'; setTimeout(function () { tip.textContent = prev; }, 1600); }
      };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(done);
      else { var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (x) {} document.body.removeChild(t); done(); }
    });
  }

  // ---- Toast reutilizable ----
  function toast(msg, ok) {
    var t = document.createElement('div');
    t.className = 'friky-toast' + (ok === false ? ' friky-toast--err' : '');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); }, 2600);
  }

  // ---- Botón FT("Añadir al carrito") en tarjetas de producto del blog ----
  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : null;
  }
  function initCartButtons() {
    var cards = document.querySelectorAll('.blog-prodcard');
    cards.forEach(function (card) {
      if (card.querySelector('.friky-atc')) return;
      var handle = handleFromHref(card.getAttribute('href'));
      if (!handle) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'friky-atc';
      btn.textContent = FT('🛒 Añadir al carrito');
      card.appendChild(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (btn.disabled) return;
        btn.disabled = true; var prev = btn.textContent; btn.textContent = FT('Añadiendo…');
        fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0];
            if (!v) throw new Error(FT('sin variante'));
            return fetch('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: { _origen: 'blog' } }] })
            });
          })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            btn.textContent = FT('✓ Añadido'); btn.classList.add('is-ok');
            toast(FT('✓ Producto añadido al carrito'), true);
            setTimeout(function () { window.location.href = '/cart?utm_source=blog&utm_medium=article'; }, 900);
          })
          .catch(function () {
            btn.disabled = false; btn.textContent = prev;
            toast(FT('No se pudo añadir. Abriendo la ficha…'), false);
            setTimeout(function () { window.location.href = '/products/' + handle; }, 900);
          });
      });
    });
  }

  // ---- Guardar artículos (localStorage) ----
  var SAVED_KEY = 'friky_saved_articles';
  function getSaved() { try { return JSON.parse(localStorage.getItem(SAVED_KEY) || '[]'); } catch (e) { return []; } }
  function setSaved(a) { try { localStorage.setItem(SAVED_KEY, JSON.stringify(a)); } catch (e) {} }
  function isSaved(id) { return getSaved().some(function (x) { return String(x.id) === String(id); }); }
  function toggleSaved(item) {
    var arr = getSaved(); var i = arr.findIndex(function (x) { return String(x.id) === String(item.id); });
    if (i >= 0) { arr.splice(i, 1); setSaved(arr); return false; }
    arr.unshift(item); setSaved(arr.slice(0, 100)); return true;
  }

  // ---- Bloque de engagement: valoraciones + vistas + guardar ----
  function starsMarkup(avg) {
    var full = Math.round(avg);
    var out = '';
    for (var i = 1; i <= 5; i++) out += '<button type="button" class="friky-star' + (i <= full ? ' is-on' : '') + '" data-v="' + i + '" aria-label="' + i + ' estrellas">★</button>';
    return out;
  }
  function initEngage() {
    var box = document.querySelector('.friky-engage');
    var api = window.FRIKY_ENGAGE_API;
    if (!box || !api) return;
    var id = box.getAttribute('data-article-id');
    var title = box.getAttribute('data-article-title') || document.title;
    var url = box.getAttribute('data-article-url') || window.location.pathname;
    if (!id) return;

    function render(s) {
      var saved = isSaved(id);
      box.innerHTML =
        '<div class="friky-engage__inner">' +
          '<div class="friky-rate">' +
            FT('<div class="friky-rate__h">¿Qué te ha parecido?</div>') +
            FT('<div class="friky-rate__sub">Tu opinión nos ayuda a mejorar el contenido</div>') +
            '<div class="friky-stars" role="group">' + starsMarkup(s.your || s.avg || 0) + '</div>' +
            '<div class="friky-rate__meta">' + (s.count ? ('<b>' + (s.avg || 0) + '</b> · ' + s.count + (s.count === 1 ? ' voto' : ' votos')) : FT('Sé el primero en valorar')) + '</div>' +
          '</div>' +
          '<div class="friky-engage__side">' +
            '<div class="friky-views" title="Lecturas">👁 <b>' + (s.views || 0) + '</b> lecturas</div>' +
            '<button type="button" class="friky-save' + (saved ? ' is-on' : '') + '">' + (saved ? '♥ Guardado' : '♡ Guardar') + '</button>' +
          '</div>' +
        '</div>';
      // votar
      box.querySelectorAll('.friky-star').forEach(function (st) {
        st.addEventListener('click', function () {
          var v = +st.getAttribute('data-v');
          fetch(api + '/rate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ key: id, value: v }) })
            .then(function (r) { return r.json(); })
            .then(function (ns) { ns.your = v; render(ns); toast(FT('✓ ¡Gracias por tu valoración!'), true); })
            .catch(function () { toast(FT('No se pudo registrar el voto'), false); });
        });
        st.addEventListener('mouseenter', function () {
          var v = +st.getAttribute('data-v');
          box.querySelectorAll('.friky-star').forEach(function (o) { o.classList.toggle('is-hover', +o.getAttribute('data-v') <= v); });
        });
      });
      var starsWrap = box.querySelector('.friky-stars');
      if (starsWrap) starsWrap.addEventListener('mouseleave', function () { box.querySelectorAll('.friky-star').forEach(function (o) { o.classList.remove('is-hover'); }); });
      // guardar
      var sv = box.querySelector('.friky-save');
      if (sv) sv.addEventListener('click', function () {
        var on = toggleSaved({ id: id, title: title, url: url, at: Date.now() });
        sv.classList.toggle('is-on', on); sv.innerHTML = on ? '♥ Guardado' : '♡ Guardar';
        toast(on ? FT('✓ Guardado en tu lista') : FT('Quitado de tu lista'), true);
      });
    }

    // pinta con lo que haya y luego trae datos reales + registra la vista
    render({ avg: 0, count: 0, views: 0 });
    fetch(api + '/stats?key=' + encodeURIComponent(id)).then(function (r) { return r.json(); }).then(render).catch(function () {});
    fetch(api + '/view', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ key: id }) })
      .then(function (r) { return r.json(); }).then(function (d) { var v = box.querySelector('.friky-views b'); if (v && d.views) v.textContent = d.views; }).catch(function () {});
  }

  // Renderiza la lista de guardados (para /pages/guardados con [data-friky-saved-list])
  function initSavedList() {
    var el = document.querySelector('[data-friky-saved-list]');
    if (!el) return;
    var arr = getSaved();
    if (!arr.length) { el.innerHTML = FT('<p class="friky-saved__empty">Aún no has guardado ningún artículo. Pulsa “♡ Guardar” en cualquier artículo del blog.</p>'); return; }
    el.innerHTML = '<div class="friky-saved__grid">' + arr.map(function (a) {
      return '<div class="friky-saved__card"><a href="' + a.url + '">' + (a.title || a.url) + '</a><button type="button" class="friky-saved__x" data-id="' + a.id + '">✕</button></div>';
    }).join('') + '</div>';
    el.querySelectorAll('.friky-saved__x').forEach(function (b) {
      b.addEventListener('click', function () { toggleSaved({ id: b.getAttribute('data-id') }); initSavedList(); });
    });
  }

  // ---- Comentarios moderados ----
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function fmtDate(ts) { try { return new Date(ts).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' }); } catch (e) { return ''; } }
  function initComments() {
    var box = document.querySelector('.friky-comments');
    var api = window.FRIKY_ENGAGE_API;
    if (!box || !api) return;
    var key = box.getAttribute('data-key');
    if (!key) return;
    var state = { comments: [], count: 0, replyTo: null };

    function tree() {
      var roots = state.comments.filter(function (c) { return !c.parent; });
      var kids = function (id) { return state.comments.filter(function (c) { return c.parent === id; }); };
      function card(c, depth) {
        return '<div class="friky-c" style="margin-left:' + (depth * 22) + 'px">' +
          '<div class="friky-c__head"><span class="friky-c__name">' + esc(c.name) + '</span><span class="friky-c__date">' + fmtDate(c.at) + '</span></div>' +
          '<div class="friky-c__body">' + esc(c.text) + '</div>' +
          (depth < 1 ? '<button type="button" class="friky-c__reply" data-id="' + c.id + '" data-name="' + esc(c.name) + '">Responder</button>' : '') +
          kids(c.id).map(function (k) { return card(k, depth + 1); }).join('') +
          '</div>';
      }
      return roots.map(function (r) { return card(r, 0); }).join('');
    }
    function render() {
      box.innerHTML =
        '<h2 class="friky-comments__h">Comentarios' + (state.count ? ' (' + state.count + ')' : '') + '</h2>' +
        '<form class="friky-cform">' +
          '<div class="friky-cform__reply" hidden></div>' +
          FT('<input class="friky-cform__name" type="text" placeholder="Tu nombre" maxlength="60" required>') +
          '<input class="friky-cform__website" type="text" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px" aria-hidden="true">' +
          FT('<textarea class="friky-cform__text" placeholder="Escribe un comentario..." maxlength="3000" required></textarea>') +
          '<div class="friky-cform__bar"><span class="friky-cform__msg"></span><button type="submit" class="friky-cform__btn">Publicar comentario</button></div>' +
          FT('<p class="friky-cform__note">Los comentarios se revisan antes de publicarse.</p>') +
        '</form>' +
        '<div class="friky-comments__list">' + (state.count ? tree() : FT('<p class="friky-comments__empty">Sé el primero en comentar.</p>')) + '</div>';

      var form = box.querySelector('.friky-cform');
      var replyBox = box.querySelector('.friky-cform__reply');
      function setReply(id, name) {
        state.replyTo = id;
        if (id) { replyBox.hidden = false; replyBox.innerHTML = 'Respondiendo a <b>' + esc(name) + '</b> <a href="#" class="friky-cform__cancel">cancelar</a>'; }
        else { replyBox.hidden = true; replyBox.innerHTML = ''; }
      }
      box.querySelectorAll('.friky-c__reply').forEach(function (b) {
        b.addEventListener('click', function () { setReply(b.getAttribute('data-id'), b.getAttribute('data-name')); form.scrollIntoView({ behavior: 'smooth', block: 'center' }); form.querySelector('.friky-cform__text').focus(); });
      });
      var cancel = replyBox.querySelector('.friky-cform__cancel');
      if (cancel) cancel.addEventListener('click', function (e) { e.preventDefault(); setReply(null); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = form.querySelector('.friky-cform__msg');
        var payload = {
          key: key,
          name: form.querySelector('.friky-cform__name').value,
          text: form.querySelector('.friky-cform__text').value,
          website: form.querySelector('.friky-cform__website').value,
          parent: state.replyTo || null
        };
        var btn = form.querySelector('.friky-cform__btn'); btn.disabled = true;
        fetch(api + '/comment', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            btn.disabled = false;
            if (!res.ok) { msg.textContent = res.j.error || FT('No se pudo enviar'); msg.className = 'friky-cform__msg is-err'; return; }
            form.querySelector('.friky-cform__text').value = '';
            setReply(null);
            msg.textContent = FT('✓ ¡Gracias! Tu comentario se publicará tras revisión.'); msg.className = 'friky-cform__msg is-ok';
          })
          .catch(function () { btn.disabled = false; msg.textContent = FT('Error de conexión'); msg.className = 'friky-cform__msg is-err'; });
      });
    }
    render();
    fetch(api + '/comments?key=' + encodeURIComponent(key)).then(function (r) { return r.json(); })
      .then(function (d) { state.comments = d.comments || []; state.count = d.count || 0; render(); }).catch(function () {});
  }

  // ---- Avísame cuando vuelva (producto agotado) ----
  function initBackInStock() {
    if (!/\/products\//.test(window.location.pathname)) return;
    var api = window.FRIKY_ENGAGE_API; if (!api) return;
    var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i); if (!m) return;
    var handle = m[1];
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var available = (p.variants || []).some(function (v) { return v.available; });
        if (available) return;
        if (document.querySelector('.friky-bis')) return;
        var box = document.createElement('div');
        box.className = 'friky-bis';
        box.innerHTML =
          FT('<div class="friky-bis__h">😢 Agotado — ¿te avisamos cuando vuelva?</div>') +
          '<form class="friky-bis__form">' +
            '<input type="email" class="friky-bis__email" placeholder="tu@email.com" required>' +
            '<input type="text" class="friky-bis__website" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px" aria-hidden="true">' +
            FT('<button type="submit">Avísame</button>') +
          '</form><span class="friky-bis__msg"></span>';
        // Colocar el FT("avísame") junto al bloque de compra (no al final, para no solaparse con relacionados).
        var pay = document.querySelector('.product-form__buttons') || document.querySelector('.shopify-payment-button') || document.querySelector('.product-form');
        if (pay && pay.parentNode) pay.parentNode.insertBefore(box, pay.nextSibling);
        else { var anchor = document.querySelector('.product__info-container, .product__info-wrapper'); if (anchor) anchor.appendChild(box); else return; }
        box.querySelector('.friky-bis__form').addEventListener('submit', function (e) {
          e.preventDefault();
          var msg = box.querySelector('.friky-bis__msg');
          fetch(api + '/notify', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ handle: handle, email: box.querySelector('.friky-bis__email').value, website: box.querySelector('.friky-bis__website').value }) })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) { msg.textContent = res.ok ? '✓ Te avisaremos por email cuando vuelva' : (res.j.error || FT('No se pudo registrar')); msg.className = 'friky-bis__msg ' + (res.ok ? 'is-ok' : 'is-err'); if (res.ok) box.querySelector('.friky-bis__form').style.display = 'none'; })
            .catch(function () { msg.textContent = FT('Error de conexión'); msg.className = 'friky-bis__msg is-err'; });
        });
      }).catch(function () {});
  }

  // ---- Historial de precio (lanzamiento vs actual) ----
  function initPriceHistory() {
    var d = window.FRIKY_LAUNCH; if (!d || !d.launch) return;
    if (document.querySelector('.friky-pricehist')) return;
    var anchor = document.querySelector('.product__info-container, .product__info-wrapper, product-form, .product-form');
    if (!anchor) return;
    var launch = Number(d.launch), current = Number(d.current);
    var el = document.createElement('div');
    el.className = 'friky-pricehist';
    var fmt = function (n) { return n.toFixed(2).replace('.', ',') + ' €'; };
    if (current < launch) {
      var pct = Math.round((1 - current / launch) * 100);
      el.innerHTML = FT('Precio de lanzamiento: <s>') + fmt(launch) + '</s> → Ahora <b>' + fmt(current) + '</b> <span class="friky-pricehist__off">-' + pct + '%</span>';
    } else {
      el.innerHTML = FT('<span class="friky-pricehist__same">✓ Mismo precio desde su lanzamiento</span>');
    }
    anchor.insertBefore(el, anchor.firstChild);
  }

  // ---- Quiz interactivo ----
  function initQuiz() {
    var box = document.querySelector('.friky-quiz'); if (!box) return;
    var slug = box.getAttribute('data-slug'); var api = box.getAttribute('data-api');
    if (!slug || !api) return;
    fetch(api + '/' + encodeURIComponent(slug)).then(function (r) { return r.json(); }).then(function (q) {
      if (!q || !q.questions) { box.innerHTML = FT('<p style="text-align:center;opacity:.7">Test no disponible.</p>'); return; }
      var answers = new Array(q.questions.length).fill(null);
      function render() {
        box.innerHTML =
          '<h1 class="frikytags__h">' + esc(q.title) + '</h1>' +
          (q.intro ? '<p class="frikytags__sub">' + esc(q.intro) + '</p>' : '') +
          '<div class="friky-quiz__qs">' + q.questions.map(function (qq, qi) {
            return '<div class="friky-quiz__q"><div class="friky-quiz__qt">' + (qi + 1) + '. ' + esc(qq.q) + '</div>' +
              qq.options.map(function (op, oi) {
                return '<label class="friky-quiz__opt"><input type="radio" name="q' + qi + '" value="' + oi + '"> ' + esc(op) + '</label>';
              }).join('') + '</div>';
          }).join('') + '</div>' +
          FT('<button type="button" class="friky-quiz__go">Ver mi resultado</button>') +
          '<div class="friky-quiz__result"></div>';
        box.querySelectorAll('input[type=radio]').forEach(function (r) {
          r.addEventListener('change', function () { answers[+r.name.slice(1)] = +r.value; });
        });
        box.querySelector('.friky-quiz__go').addEventListener('click', function () {
          if (answers.some(function (a) { return a === null; })) { alert(FT('Responde todas las preguntas 🙂')); return; }
          fetch(api + '/' + encodeURIComponent(slug) + '/result', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ answers: answers }) })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var res = d.result; if (!res) return;
              var el = box.querySelector('.friky-quiz__result');
              el.innerHTML = '<div class="friky-quiz__card">' + (res.image ? '<img src="' + esc(res.image) + '" alt="">' : '') +
                '<div class="friky-quiz__rtitle">' + esc(res.title) + '</div>' +
                '<p>' + esc(res.text) + '</p>' +
                (res.url ? '<a class="friky-quiz__cta" href="' + esc(res.url) + FT('">Ver recomendaciones →</a>') : '') + '</div>';
              el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }).catch(function () {});
        });
      }
      render();
    }).catch(function () { box.innerHTML = FT('<p style="text-align:center;opacity:.7">No se pudo cargar el test.</p>'); });
  }

  // Caja de plástico (app de opciones): moverla JUSTO debajo del FT("Añadir a la cesta")
  // (por encima de Características) y darle color corporativo. Se preserva su JS al mover el nodo.
  function initGiftBox() {
    if (!/\/products\//.test(location.pathname)) return;
    function anchorEl() {
      var pay = document.querySelector('.shopify-payment-button');
      var form = pay ? (pay.closest('product-form') || pay.closest('.product-form') || pay.parentNode) : null;
      return form || document.querySelector('.product-form__buttons');
    }
    function styleBox(box) {
      // La app pinta el gris con estilos INLINE !important; solo se puede pisar con inline por JS.
      box.style.setProperty('background', 'transparent', 'important');
      box.style.setProperty('background-image', 'none', 'important');
      box.style.setProperty('border', 'none', 'important');
      box.style.setProperty('border-radius', '0', 'important');
      box.style.setProperty('box-shadow', 'none', 'important');
      box.style.setProperty('display', 'block', 'important');
      box.style.setProperty('position', 'static', 'important'); // que nunca flote sobre el precio
      box.style.setProperty('width', '100%', 'important');
      box.style.setProperty('max-width', '100%', 'important');
      box.style.setProperty('flex', '1 1 100%', 'important'); // por si el contenedor es flex
      box.style.setProperty('align-self', 'stretch', 'important');
      box.style.setProperty('box-sizing', 'border-box', 'important');
      box.style.setProperty('margin', '10px 0', 'important');
      box.style.setProperty('padding', '7px 16px', 'important');
      // Compactar el interior (la app mete mucho espacio arriba/abajo).
      if (box.firstElementChild) { box.firstElementChild.style.setProperty('margin', '0', 'important'); box.firstElementChild.style.setProperty('padding', '0', 'important'); }
      // Tipografía un poco más grande.
      var ttl = box.querySelector('.apo-value-title'); if (ttl) ttl.style.setProperty('font-size', '15px', 'important');
      var help = box.querySelector('.apo-value-help-text'); if (help) help.style.setProperty('font-size', '13px', 'important');
      var kids = box.querySelectorAll('*');
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        var isCheck = el.tagName === 'INPUT' || /checkbox|checkmark|check-icon|__check\b/i.test(el.className || '');
        if (!isCheck) { el.style.setProperty('background', 'transparent', 'important'); el.style.setProperty('background-color', 'transparent', 'important'); }
        el.style.setProperty('box-shadow', 'none', 'important');
        el.style.setProperty('color', '#1b2026', 'important');
        el.style.setProperty('margin-top', '0', 'important');
        el.style.setProperty('margin-bottom', '0', 'important');
        el.style.setProperty('padding-top', '0', 'important');
        el.style.setProperty('padding-bottom', '0', 'important');
      }
      // Casilla en BLANCO para que se vea clicable (la app la deja del color de fondo).
      var boxes = box.querySelectorAll('input[type=checkbox],input[type=radio]');
      for (var j = 0; j < boxes.length; j++) {
        var cb = boxes[j];
        cb.style.setProperty('appearance', 'auto', 'important');
        cb.style.setProperty('-webkit-appearance', 'auto', 'important');
        cb.style.setProperty('opacity', '1', 'important');
        cb.style.setProperty('position', 'static', 'important');
        cb.style.setProperty('width', '18px', 'important');
        cb.style.setProperty('height', '18px', 'important');
        cb.style.setProperty('min-width', '18px', 'important');
        cb.style.setProperty('background', '#fff', 'important');
        cb.style.setProperty('background-color', '#fff', 'important');
        cb.style.setProperty('border', '1.5px solid #9aa4b2', 'important');
        cb.style.setProperty('border-radius', '4px', 'important');
        cb.style.setProperty('accent-color', '#1b2026', 'important');
      }
    }
    function tryMove() {
      var box = document.getElementById('avpoptions-container__v2');
      if (!box) return;
      box.classList.add('friky-giftbox');
      styleBox(box);
      // Preferente: JUSTO debajo del botón FT("Añadir a la cesta") (antes de Comprar con Shop).
      var pay = document.querySelector('.shopify-payment-button');
      if (pay && pay.parentNode) { if (pay.previousElementSibling !== box) pay.parentNode.insertBefore(box, pay); return; }
      var submit = document.querySelector('.product-form__submit');
      if (submit && submit.parentNode) { if (submit.nextElementSibling !== box) submit.parentNode.insertBefore(box, submit.nextElementSibling); return; }
      var a = anchorEl();
      if (a && a.parentNode && a.nextElementSibling !== box) a.parentNode.insertBefore(box, a.nextElementSibling);
    }
    tryMove();
    // Reafirma la posición un rato porque la app puede recolocarla (carrera).
    var n = 0, iv = setInterval(function () { tryMove(); if (++n > 18) clearInterval(iv); }, 500);
  }

  // Traducir al español los avisos en inglés de la app de opciones (caja de plástico).
  function initApoTranslate() {
    if (!/\/products\//.test(location.pathname)) return;
    var pairs = [
      ['This product cannot be purchased using this checkout method. Please add the item to cart, then proceed to checkout from the cart.', FT('Este producto no se puede comprar con el pago rápido. Añádelo a la cesta y finaliza la compra desde la cesta.')],
      ['Please add the item to cart, then proceed to checkout from the cart.', FT('Añádelo a la cesta y finaliza la compra desde la cesta.')],
      ['This product cannot be purchased using this checkout method.', FT('Este producto no se puede comprar con el pago rápido.')],
      ['This item has been added to your cart', FT('Producto añadido a la cesta')],
      ['has been added to your cart', FT('añadido a la cesta')],
      ['added to your cart', FT('añadido a la cesta')],
    ];
    var root = document.querySelector('#MainContent') || document.body;
    function run() {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var nodes = [], n;
      while ((n = w.nextNode())) nodes.push(n);
      for (var i = 0; i < nodes.length; i++) {
        var tn = nodes[i], t = tn.nodeValue;
        if (!t || t.indexOf('This ') < 0 && t.indexOf('added to your cart') < 0 && t.indexOf('checkout method') < 0) continue;
        for (var j = 0; j < pairs.length; j++) if (t.indexOf(pairs[j][0]) >= 0) t = t.split(pairs[j][0]).join(pairs[j][1]);
        if (t !== tn.nodeValue) tn.nodeValue = t;
      }
    }
    run();
    var pend = false;
    var mo = new MutationObserver(function () { if (pend) return; pend = true; setTimeout(function () { pend = false; run(); }, 200); });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }

  // Widget de SeQura: el script de SeQura inyecta el teaser en CADA elemento de precio que casa con
  // su selector, y el tema pinta el precio en varios sitios (escritorio + móvil/oculto) → sale DUPLICADO.
  // Solución: dejar UN SOLO teaser (el primero visible, o el primero si ninguno lo está), eliminar el resto,
  // y colocarlo justo debajo del bloque de pago. Se reintenta para cazar la inyección tardía del script.
  function initSequra() {
    if (!/\/products\//.test(location.pathname)) return;
    function isVisible(el) { return !!(el && (el.offsetParent || el.getClientRects().length)); }
    function dedupeAndMove() {
      var all = Array.prototype.slice.call(document.querySelectorAll('.sequra-promotion-widget'));
      if (all.length) {
        var keep = all.filter(isVisible)[0] || all[0];         // conservamos uno (preferimos visible)
        all.forEach(function (w) { if (w !== keep) { try { w.remove(); } catch (e) { w.style.display = 'none'; } } });
        var pay = document.querySelector('.shopify-payment-button');
        if (pay && pay.parentNode && pay.nextElementSibling !== keep) pay.parentNode.insertBefore(keep, pay.nextElementSibling);
      }
    }
    dedupeAndMove();
    var n = 0, iv = setInterval(function () { dedupeAndMove(); if (++n > 24) clearInterval(iv); }, 500);
    // Vigilancia permanente por si el script de SeQura re-inyecta un duplicado más tarde.
    try {
      var mo = new MutationObserver(function () { dedupeAndMove(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    } catch (e) { /* navegadores sin MutationObserver */ }
  }

  // Bloque de DESTACADOS en páginas de categoría: 12 productos de la colección de 24-49 €
  // (excluye los baratos tipo Funko), barajados (varían en cada carga), en carrusel de 4.
  function initCollectionFeatured() {
    if (!document.body.classList.contains('collection-template')) return;
    if (document.querySelector('.friky-feat')) return;
    var m = window.location.pathname.match(/\/collections\/([a-z0-9-]+)/i);
    if (!m) return;
    var handle = m[1];
    fetch('/collections/' + handle + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).map(function (p) {
          var price = Math.min.apply(null, (p.variants || []).map(function (v) { return parseFloat(v.price) || 9999; }));
          return { title: p.title, handle: p.handle, price: price, img: (p.images && p.images[0] && p.images[0].src) || '' };
        }).filter(function (p) { return p.price >= 24 && p.price <= 49 && p.img; });
        if (prods.length < 4) return; // si no hay suficientes, no molestamos
        // barajar y quedarnos con 12
        for (var i = prods.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = prods[i]; prods[i] = prods[j]; prods[j] = t; }
        prods = prods.slice(0, 12);
        var cards = prods.map(function (p) {
          return '<a class="friky-feat__card" href="/products/' + p.handle + '">' +
            '<img src="' + p.img + (p.img.indexOf('?') < 0 ? '?width=300' : '') + '" alt="" loading="lazy">' +
            '<span class="n">' + (p.title.length > 60 ? p.title.slice(0, 60) + '…' : p.title) + '</span>' +
            '<span class="p">' + p.price.toFixed(2).replace('.', ',') + ' €</span></a>';
        }).join('');
        var wrap = document.createElement('div');
        wrap.className = 'friky-feat';
        wrap.innerHTML =
          FT('<div class="friky-feat__head"><div class="friky-feat__t">✨ No te lo pierdas</div>') +
          FT('<div class="friky-feat__sub">Una selección para que descubras cosas nuevas</div></div>') +
          '<div class="friky-feat__car">' +
            '<button type="button" class="friky-feat__arw friky-feat__arw--l" data-d="-1" aria-label="Anterior">‹</button>' +
            '<div class="friky-feat__vp"><div class="friky-feat__track">' + cards + '</div></div>' +
            '<button type="button" class="friky-feat__arw friky-feat__arw--r" data-d="1" aria-label="Siguiente">›</button>' +
          '</div>';
        var grid = document.querySelector('#ProductsList, .products-list, .product-grid, #product-grid') || document.querySelector('[id$="__product-grid"] .grid-list, [id$="__product-grid"]');
        // Insertar ANTES de la sección completa de productos (nivel superior), para no afectar
        // al contenedor de la rejilla (evita que su carrusel descuadre las columnas).
        var section = document.querySelector('[id^="shopify-section"][id$="__product-grid"]') || (grid && grid.closest && grid.closest('.shopify-section'));
        if (section && section.parentNode) {
          // Envolver en .page-width para que quede centrado y con el MISMO ancho que la rejilla
          // (si no, ocuparía todo el viewport y no se adaptaría al reducir la ventana).
          var pw = document.createElement('div'); pw.className = 'page-width friky-feat-wrap';
          pw.appendChild(wrap);
          section.parentNode.insertBefore(pw, section);
        } else if (grid && grid.parentNode) grid.parentNode.insertBefore(wrap, grid);
        else { var main = document.querySelector('#MainContent'); if (main) main.insertBefore(wrap, main.firstChild); }
        // Carrusel por TRANSFORM dentro de un visor con overflow:hidden (no puede desbordar la página).
        var vp = wrap.querySelector('.friky-feat__vp'), track = wrap.querySelector('.friky-feat__track');
        var arwL = wrap.querySelector('.friky-feat__arw--l'), arwR = wrap.querySelector('.friky-feat__arw--r');
        var pos = 0;
        function maxPos() { return Math.max(0, track.scrollWidth - vp.clientWidth); }
        function apply() { track.style.transform = 'translateX(' + (-pos) + 'px)'; arwL.disabled = pos <= 0; arwR.disabled = pos >= maxPos() - 1; }
        function move(dir) { pos = Math.max(0, Math.min(maxPos(), pos + dir * vp.clientWidth * 0.9)); apply(); }
        arwL.addEventListener('click', function () { move(-1); });
        arwR.addEventListener('click', function () { move(1); });
        window.addEventListener('resize', function () { pos = Math.min(pos, maxPos()); apply(); });
        apply();
      }).catch(function () { /* silencioso */ });
  }

  // En /collections/all el contador de Shopify topa en ~25.001. Lo sustituimos por el nº REAL
  // de productos de la web (dato en vivo cacheado desde frikyshop).
  function initRealProductCount() {
    if (!/\/collections\/all\b/.test(window.location.pathname)) return;
    var el = document.getElementById('ProductCount');
    if (!el) return;
    var api = window.FRIKY_SILVIA_API; if (!api) return;
    fetch(api + '/product-count').then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.count > 0) el.textContent = new Intl.NumberFormat('es-ES').format(d.count) + ' productos';
    }).catch(function () { /* */ });
  }

  // Botón de SCROLL INFINITO opcional en categorías (el usuario elige; se recuerda su preferencia).
  function initInfiniteScroll() {
    if (!document.body.classList.contains('collection-template')) return;
    var pag = document.querySelector('.pagination');
    var list = document.querySelector('#ProductsList, .products-list, .product-grid');
    if (!pag || !list) return;
    var KEY = 'friky_infscroll_v2'; // clave nueva → resetea preferencias antiguas: por defecto PAGINACIÓN
    var on = localStorage.getItem(KEY) === '1';
    var nextUrl = null, loading = false, onScroll = null;

    var bar = document.createElement('div');
    bar.className = 'friky-inf';
    bar.innerHTML = '<button type="button" class="friky-inf__btn"><span class="friky-inf__ico">♾️</span> <span class="friky-inf__lbl"></span></button>';
    pag.parentNode.insertBefore(bar, pag);
    var btn = bar.querySelector('.friky-inf__btn'), lbl = bar.querySelector('.friky-inf__lbl');
    var LBL_ON = FT('Scroll infinito activado · volver a páginas'), LBL_OFF = FT('Ver en scroll infinito');

    function nextLink(doc) { var l = (doc || document).querySelector('link[rel="next"]'); if (l && l.getAttribute('href')) return l.getAttribute('href'); var a = (doc || document).querySelector('a.pagination__item--next[href], .pagination__item--next a[href]'); return a ? a.getAttribute('href') : null; }
    function loadMore() {
      if (loading || !nextUrl) return;
      loading = true; lbl.textContent = 'Cargando…';
      fetch(nextUrl, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nl = doc.querySelector('#ProductsList, .products-list, .product-grid');
        if (nl) Array.prototype.slice.call(nl.children).forEach(function (c) { list.appendChild(document.importNode(c, true)); });
        nextUrl = nextLink(doc);
        loading = false;
        lbl.textContent = nextUrl ? LBL_ON : FT('No hay más productos · volver a páginas');
        // Si aún queda contenido visible por debajo, seguir cargando en cadena.
        if (nextUrl && list.getBoundingClientRect().bottom < window.innerHeight + 300) loadMore();
      }).catch(function () { loading = false; lbl.textContent = LBL_ON; });
    }
    function startInf() {
      pag.style.display = 'none';
      nextUrl = nextLink();
      onScroll = function () { if (nextUrl && !loading && list.getBoundingClientRect().bottom < window.innerHeight + 700) loadMore(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll(); // carga si ya estás abajo; si no, espera al scroll
    }
    var floatBtn = null;
    function ensureFloat() {
      if (floatBtn) { floatBtn.style.display = ''; return; }
      floatBtn = document.createElement('button');
      floatBtn.type = 'button';
      floatBtn.className = 'friky-inf-float';
      floatBtn.innerHTML = '☰ Ver por páginas';
      document.body.appendChild(floatBtn);
      floatBtn.addEventListener('click', function () { localStorage.setItem(KEY, '0'); window.location.reload(); });
    }
    function render() {
      if (on) {
        // El botón normal queda al fondo (inalcanzable con scroll infinito) → se oculta y
        // se usa un botón FLOTANTE discreto para volver a la vista por páginas.
        bar.style.display = 'none';
        ensureFloat();
        startInf();
      } else {
        bar.style.display = '';
        btn.classList.remove('on');
        lbl.textContent = LBL_OFF;
        if (floatBtn) floatBtn.style.display = 'none';
      }
    }
    // El cambio de modo RECARGA la página para pasar limpio de paginación a infinito y viceversa.
    btn.addEventListener('click', function () { localStorage.setItem(KEY, on ? '0' : '1'); window.location.reload(); });
    render();
  }

  // Agotados SIEMPRE al final de la categoría (Shopify no ordena por disponibilidad).
  function initSoldOutLast() {
    if (!document.body.classList.contains('collection-template')) return;
    var list = document.querySelector('#ProductsList, .products-list, .product-grid');
    if (!list) return;
    var m = window.location.pathname.match(/\/collections\/([a-z0-9-]+)/i); if (!m) return;
    var avail = null, mo = null;
    function reorder() {
      if (!avail) return;
      var cards = Array.prototype.slice.call(list.children);
      var soldout = [];
      cards.forEach(function (c) {
        var a = c.querySelector && c.querySelector('a[href*="/products/"]'); if (!a) return;
        var mm = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/i); if (!mm) return;
        if (avail[mm[1]] === false) soldout.push(c);
      });
      if (!soldout.length) return;
      // ¿ya están todos al final? entonces no tocar (evita bucle del observer)
      var tail = cards.slice(cards.length - soldout.length);
      if (soldout.every(function (c) { return tail.indexOf(c) >= 0; })) return;
      if (mo) mo.disconnect();
      soldout.forEach(function (c) { list.appendChild(c); });
      if (mo) mo.observe(list, { childList: true });
    }
    fetch('/collections/' + m[1] + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        avail = {};
        (data.products || []).forEach(function (p) { avail[p.handle] = (p.variants || []).some(function (v) { return v.available; }); });
        reorder();
        // Reaplicar si el tema re-renderiza la rejilla (filtros/orden/paginación AJAX).
        mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(reorder, 250); });
        mo.observe(list, { childList: true });
      }).catch(function () { /* */ });
  }

  // Faldón sticky de FT("Añadir a la cesta"): ocultar mientras se hace scroll, reaparecer al parar.
  function initStickyAtc() {
    var bar = null, t = null;
    function onScroll() {
      bar = bar || document.querySelector('.sticky-atc-bar');
      if (!bar) return;
      bar.classList.add('friky-atc-scrolling');
      clearTimeout(t);
      t = setTimeout(function () { bar.classList.remove('friky-atc-scrolling'); }, 240);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  // Buscador: NUESTRO globo gestiona toda la búsqueda. Bloqueamos el input nativo del tema
  // (solo lectura) para que al pulsarlo se abra nuestro buscador y no la búsqueda nativa.
  function initSearchLock() {
    var SEL = '.search__input, input[type="search"][name="q"]';
    // Input de SOLO LECTURA: no se escribe en la caja nativa; al pulsarla se abre
    // nuestro buscador (friky-buscador.js gestiona la búsqueda). Evita la búsqueda nativa.
    function harden(inp) { if (inp && !inp.hasAttribute('readonly')) { inp.setAttribute('readonly', 'readonly'); inp.setAttribute('aria-readonly', 'true'); } }
    function hardenAll() { document.querySelectorAll(SEL).forEach(harden); }
    hardenAll();
    // Re-aplicar por si el header se recarga (menú móvil, etc.).
    document.addEventListener('focusin', function (e) { var inp = e.target.closest && e.target.closest(SEL); if (inp) harden(inp); }, true);
    var n = 0, iv = setInterval(function () { hardenAll(); if (++n > 10) clearInterval(iv); }, 500);
  }

  // ---- Guardián del precio: si una app (opciones/caja de plástico) vacía el bloque de precio, lo restauramos ----
  function initPriceGuard() {
    if (!/\/products\//.test(location.pathname)) return;
    var block = document.querySelector('.product__block--price');
    var host = document.querySelector('[id^="price-template"]') || block;
    if (!host || !block) return;
    function regItem() { return host.querySelector('.f-price-item--regular, .price-item--regular'); }
    function saleItem() { return host.querySelector('.f-price-item--sale, .price-item--sale'); }
    function num(el) { return el && /\d/.test(el.textContent || ''); }
    if (!num(regItem()) && !num(saleItem())) return; // no habia precio de inicio
    var saved = host.innerHTML; // precio correcto del HTML del servidor
    function unhide(el, disp) {
      if (!el) return;
      if (el.classList.contains('hidden')) el.classList.remove('hidden');
      if (el.style && el.style.display === 'none') el.style.display = '';
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none') el.style.setProperty('display', disp, 'important');
      if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
      if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
    }
    function fix() {
      // vaciado del todo -> restaurar el precio bueno del servidor
      if (!num(regItem()) && !num(saleItem())) { host.innerHTML = saved; }
      else if (host.innerHTML !== saved) saved = host.innerHTML; // precio valido nuevo (variante) -> memorizar
      // des-ocultar SOLO el contenedor (el tema ya decide regular vs oferta -> sin duplicar)
      unhide(block, 'block'); unhide(host, 'block'); unhide(host.querySelector('.f-price'), 'block'); var _fps = block.querySelectorAll('.f-price'); for (var _i = 1; _i < _fps.length; _i++) _fps[_i].style.setProperty('display', 'none', 'important');
    }
    fix();
    var n = 0, iv = setInterval(function () { fix(); if (++n > 40) clearInterval(iv); }, 300); // ~12s
    try { new MutationObserver(fix).observe(block, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] }); } catch (e) {}
  }

  ready(function () { initReadingProgress(); initCopyLink(); initCartButtons(); initEngage(); initSavedList(); initComments(); initBackInStock(); initPriceHistory(); initQuiz(); initStickyAtc(); initGiftBox(); initSequra(); initPriceGuard(); initApoTranslate(); initSearchLock(); initCollectionFeatured(); initSoldOutLast(); initInfiniteScroll(); initRealProductCount(); });
})();

